export const defaultMetrices = ["spends","orders","cpm","sale_value","impressions","clicks","ctr","cpc","cvr","aov","roas","acos"]

export const EXTRA_METRICES_FOR_PRODUCT_ADS = ["maximum_retail_price","sale_price","discount_percentage","total_units_sold","total_asp","organic_sales_percentage","troas","tacos","total_revenue","quantity"] 
